import { useQueryClient } from '@tanstack/react-query';

import useQuery from '@/core/hooks/api/useQuery';
import { ErrorKind } from '@/core/lib/fetch';
import Api from '@/core/lib/new-architecture/api';
import getToken from '@/core/lib/new-architecture/query/token';
import type { Query } from '@/core/lib/new-architecture/query/types.query';

const keys = {
  base: ['KEY_TO_PREVENT_COLLISIONS', '/user', '/badges'] as const,
};

const useBadges: Query<Awaited<ReturnType<typeof Api.query.user.badges>>> = ({ enabled, token }) => {
  return useQuery({
    queryKey: keys.base,
    queryFn: async () => {
      return Api.query.user.badges(await getToken(token));
    },
    enabled,
    retry: (failureCount, error) => {
      if (error.kind === ErrorKind.Unauthorized) {
        return false;
      }

      return failureCount < 3;
    },
  });
};

const useInvalidate = () => {
  const queryClient = useQueryClient();

  const invalidate = () => queryClient.invalidateQueries({ queryKey: keys.base });

  return { invalidate };
};

export default { useBadges, useInvalidate };
